import Axios from "axios";
import { isEmpty } from "lodash";

const AUTO_DATA_FETCH_SUCCESS = "AUTO_DATA_FETCH_SUCCESS";
const AUTO_DATA_FETCH_FAIL = "AUTO_DATA_FETCH_FAIL";
export const autoData = (data) => {
    if (data) {
        return {
            type: AUTO_DATA_FETCH_SUCCESS,
            autoData: data,
        }
    } else {
        return {
            type: AUTO_DATA_FETCH_FAIL,
            autoData: {},
        }
    }

}

export function preData(draftKey) {
    return (dispatch) => {
        return Axios.get(`${process.env.REACT_APP_COMMON_GATEWAY}/vendor_onboarding/vendor_draft?slug=${draftKey}`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `${localStorage.getItem("apiToken")}`,
            },
        }).then((response) => {
            if (!isEmpty(response)) {
                dispatch(autoData(JSON.parse(response.data.resultSet[0]['draftData'])));
                return new Promise(function (resolve) {
                    resolve(JSON.parse(response.data.resultSet[0]['draftData']))
                })
            }
        }).catch((error) => {
            if (error.response.status === 422) dispatch(autoData([]));
            // console.log('>>>', error.response.status)
        })
    }
}

export const autoDataReducer = (state = {}, action) => {
    switch (action.type) {
        case AUTO_DATA_FETCH_SUCCESS:
            return {
                ...state,
                autoData: action.autoData
            }
        case AUTO_DATA_FETCH_FAIL:
            return {
                ...state,
                autoData: {},
            }
        default: return state
    }
}